import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import { Moment } from "moment";

interface renderTitlesProps {
  pdf: jsPDF;
  bigFontSize: number;
  normalFontSize: number;
  driverName: string;
  font: string;
  dateRange?: {
    fromDate: Moment;
    toDate: Moment;
  };
}

export const renderTitleAndDateRange = ({
  pdf,
  bigFontSize,
  normalFontSize,
  dateRange,
  driverName,
  font
}: renderTitlesProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  const reportDateRange = dateRange
    ? `${dateRange.fromDate.format("DD/MM/YYYY")} - ${dateRange.toDate.format("DD/MM/YYYY")}`
    : t("All time");

  pdf
    .setFontSize(bigFontSize)
    .setFont(font, "normal", "bold")
    .text(`${driverName} ${t("deliveries report")}`, pageWidth / 2, 40, {
      align: "center"
    });

  pdf.setFontSize(normalFontSize).setFont(font, "normal", "normal");
  pdf.text(`${t("Date range")}: ${reportDateRange}`, 30, 65);
};
